module.exports = __webpack_public_path__ + "img/sweden-liver-cancer-female.55b36e5a.png";